import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Typography from '@material-ui/core/Typography';
import TaggedTopicInfo from './TaggedTopicInfo';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 17,
    lineHeight: '21px',
  },
}));

function TaggedTopics({ data }) {
  const classes = useStyles();
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);
  if (_isEmpty(data)) return null;
  return (
    <Box component="div" display="flex" flexDirection="column" mt="32px">
      <Box component="span">
        <Typography className={classes.title}>
          {_get(resourceItemPageSiteCopy, 'pageCopy.taggedTopicsHeader')}
        </Typography>
      </Box>
      {data.map((el, index) => (
        <TaggedTopicInfo data={el} key={_get(el, 'fields.slug', index)} />
      ))}
    </Box>
  );
}

TaggedTopics.propTypes = {
  data: PropTypes.array,
};

export default TaggedTopics;
